import { createStyle } from "@gluestack-style/react";

export const ButtonIcon = createStyle({
  props: {
    size: "md"
  }
});
